import React, { useState } from 'react';
import Attention from '../../ReusableComponents/Attention';
import PortalFieldHelp from './PortalFieldHelp';
import { positionFieldDescriptions } from './registrationFieldDescriptions';
import { localDate } from '../registrationConfiguration';

export default function PositionAccessSettings({ source, prefix }) {
  const [examEnabled, setExamEnabled] = useState(!!source.portal_exam_enabled);
  return (
    <div className="portal-config-access">
      <h4>Habilitação na OnTest</h4>
      <label className="portal-check">
        <input
          type="checkbox"
          name={prefix + 'portal_position_enabled'}
          defaultChecked={!!source.portal_position_enabled}
        />{' '}
        Permitir inscrição neste cargo
        <PortalFieldHelp label="Permitir inscrição neste cargo">
          {positionFieldDescriptions.portal_position_enabled}
        </PortalFieldHelp>
      </label>
      <label className="portal-check">
        <input
          type="checkbox"
          name={prefix + 'portal_exam_enabled'}
          checked={examEnabled}
          onChange={(event) => setExamEnabled(event.target.checked)}
        />{' '}
        Habilitar acesso à prova pelo portal
        <PortalFieldHelp label="Habilitar acesso à prova pelo portal">
          {positionFieldDescriptions.portal_exam_enabled}
        </PortalFieldHelp>
      </label>
      <div className="portal-admin-grid">
        {[
          ['portal_exam_starts_at', 'Acesso à prova a partir de'],
          ['portal_exam_ends_at', 'Acesso à prova até'],
        ].map(([name, label]) => (
          <label className="form-label" key={name}>
            <span>
              {label}{' '}
              {examEnabled ? <Attention /> : <small className="text-muted">(opcional)</small>}
              <PortalFieldHelp label={label}>{positionFieldDescriptions[name]}</PortalFieldHelp>
            </span>
            <input
              className="form-control"
              name={prefix + name}
              type="datetime-local"
              required={examEnabled}
              defaultValue={localDate(source[name])}
            />
          </label>
        ))}
      </div>
    </div>
  );
}
